import { ApolloCache, useApolloClient } from '@apollo/client';

export const useApolloCache = (): ApolloCache<object> => {
  const apolloClient = useApolloClient();
  return apolloClient.cache;
};
